import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import { formatUrl } from "@utils/formatUrl";

let serverUrl = getSecret('SERVER_AUTH_URL')
let masterUrl = getSecret('SERVER_MASTER_URL')

export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_PERM(state, perms) {
    state.cached = perms
  },
}

export const actions = {
  init({ state, dispatch }) {},

  fetchAllFlags(context, query = '') {
    return axios.get(`https://restcountries.com/v3.1/all?fields=cca2,name,idd,flags`).then((response) => {
      const request = response.data
      return request
    })
  },

  fetchAllCountry(context, query = '') {
    return axios.get(`${masterUrl}/api/country/${query}`).then((response) => {
      const request = response.data.results
      return request
    })
  },

  fetchAllMunicipality(context, query = '') {
    return axios.get(`${masterUrl}/api/municipality/${query}`).then((response) => {
      return response.data.results
    })
  },
  fetchAllDeparment(context, query = '') {
    return axios.get(`${masterUrl}/api/deparments/${query}`).then((response) => {
      return response.data.results
    })
  },
  fetchAllMasters(context, id = '') {
    return axios.get(`${serverUrl}/api/masters/${id}`).then((response) => {
      return response.data
    })
  }
}
